import React, { useState, useRef, useEffect, useMemo, useCallback, } from 'react';
import * as moment from 'moment';
import { bem, use, classnames } from '../../lib';
import { Icon } from '../Icon';
import debounceFunction from 'lodash/debounce';
import ReactDatePicker from 'react-datepicker';
import { useNumberInput } from '../';
const DatePicker = ReactDatePicker;
/**
 * Input component
 *
 * @visibleName Input
 */
export const Input = (props) => {
    const { name, size, debounce, value: externalValue, placeholder, label, type, revealer, className, required, icon, secondary, search, onBlur, onFocus, onChange, format, asString, noRequiredStyle, autoFocus, onKeyDown, onKeyPress, readOnly, fullWidth, innerRef, borderless, autoComplete, } = props;
    const [isFocussed, setIsFocussed] = useState(false);
    const [inputType, setType] = useState(type);
    const inputElement = useRef(null);
    const [value, setInternalValue] = useState(externalValue);
    useEffect(() => {
        setInternalValue(externalValue);
    }, [externalValue, setInternalValue]);
    const parseToDate = useCallback((value) => {
        const date = moment.utc(value).toDate();
        return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    }, []);
    const parseFromDate = useCallback((date, format = 'DD MMM YYYY') => {
        if (!date)
            return '';
        return moment.parseZone(date).format(format);
    }, []);
    useEffect(() => {
        if (innerRef) {
            innerRef(inputElement.current);
        }
    }, [inputElement.current]);
    const handleLabelClick = () => {
        if (inputElement.current && type !== 'date')
            inputElement.current.focus();
    };
    const debouncedOnChange = useMemo(() => onChange && debounce > 0 ? debounceFunction(onChange, debounce) : null, [onChange, debounce]);
    const handleDateChange = useCallback((value, e) => {
        if (type === 'date') {
            if (moment.isDate(value)) {
                onChange(parseFromDate(value), e);
            }
            else {
                onChange(value, e);
            }
        }
    }, [onChange, parseFromDate]);
    // remove number input stuffs
    const handleChange = useCallback((e) => {
        const changeFunc = debouncedOnChange || onChange;
        setInternalValue(e.target.value || '');
        if (!changeFunc)
            return;
        changeFunc(e.target.value || '', e);
    }, [debouncedOnChange, onChange, setInternalValue]);
    const handleFocus = useCallback((event) => {
        setIsFocussed(true);
        if (onFocus)
            onFocus(event);
    }, [onFocus, setIsFocussed]);
    const handleBlur = useCallback((event) => {
        setIsFocussed(false);
        if (onBlur)
            onBlur(value, event);
    }, [onBlur, setIsFocussed, value]);
    const handleRevealerClick = () => {
        inputType === 'text' ? setType('password') : setType('text');
    };
    const renderInput = (extraProps = {}) => (React.createElement("input", Object.assign({ name: name, autoFocus: autoFocus, className: bem('input-group__input', use(size, () => `--${size.replace('.', '_')}`, '--2'), use(value, '--is-filled'), use(isFocussed, '--is-focussed')), value: value, placeholder: placeholder, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: onKeyDown, onKeyPress: onKeyPress, ref: inputElement, type: type !== 'number' ? inputType : undefined, required: required, readOnly: readOnly, autoComplete: autoComplete }, extraProps)));
    return (React.createElement("div", { className: classnames(bem('input-group', use(isFocussed, '--is-focussed'), use(secondary, '--secondary'), use(search, '--search'), use(borderless, '--borderless'), use(!noRequiredStyle && required, '--is-required'), use(fullWidth, '--full-width')), className), onClick: handleLabelClick },
        icon && (React.createElement("div", { className: bem('input-group__icon', '--left') },
            React.createElement(Icon, { name: icon }))),
        label && (React.createElement("label", { htmlFor: name, className: bem('input-group__label', use(value, '--is-filled'), use(size, () => `--${size.replace('.', '_')}`, '--2'), use(isFocussed, '--is-focussed')) }, label)),
        type === 'number' ? (React.createElement("input", Object.assign({ name: name, autoFocus: autoFocus, placeholder: placeholder, className: bem('input-group__input', use(size, () => `--${size.replace('.', '_')}`, '--2'), use(value, '--is-filled'), use(isFocussed, '--is-focussed')), onKeyDown: onKeyDown, onKeyPress: onKeyPress, ref: inputElement, required: required, readOnly: readOnly, autoComplete: autoComplete }, useNumberInput({
            asString,
            format,
            onBlur: onBlur ? (e) => onBlur(value, e) : undefined,
            onChange,
            onFocus,
            value,
        }), { type: "text" }))) : type === 'date' ? (React.createElement(DatePicker, { name: name, allowSameDay: true, dateFormat: (format || 'DD MMM YYYY')
                .toLowerCase()
                .replace(/m/g, 'M'), selected: value ? parseToDate(value) : null, onChange: handleDateChange, onBlur: handleBlur, autoFocus: autoFocus, className: bem('input-group__input', use(size, () => `--${size.replace('.', '_')}`, '--2'), use(value, '--is-filled'), use(isFocussed, '--is-focussed')), placeholder: placeholder, onFocus: handleFocus, onKeyDown: onKeyDown, onKeyPress: onKeyPress, ref: inputElement, required: required, readOnly: readOnly })) : (renderInput()),
        type === 'password' && revealer && (React.createElement("button", { type: "button", tabIndex: -1, onClick: handleRevealerClick, className: bem('input-group__password-revealer', inputType === 'text' ? '--is-active' : null) },
            React.createElement(Icon, { name: "visibility" })))));
};
//# sourceMappingURL=Input.js.map